import { useFleets } from '@src/main/modules/messages/ui/mailbox/hooks/new-message/useFleets';
import { mapFleetToOption } from '@src/main/modules/messages/ui/mailbox/model/fleet-time-option.model';

export const useFleetOptions = (fleet: string, subFleet: string) => {
  const result = useFleets(fleet, subFleet);

  const fleetData = result.data ?? [];
  const options = fleetData.map(mapFleetToOption);

  return { ...result, options };
};
